// extracted by mini-css-extract-plugin
export default {"ActionList_LinkItem":"ChatReference-module__ActionList_LinkItem--gopkk"};